export default __webpack_public_path__ + "static/media/JXImg.e6c2261b.png";